"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdSendBeacon = _interopRequireDefault(require("cccisd-send-beacon"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Boilerplate = window.cccisd.boilerplate;
var savePeriod = 5 * 60 * 1000; // Save events every 5 minutes
var events = [];
function saveEvents() {
  if (events.length === 0) {
    return;
  }

  // we are not waiting for the request finished
  _cccisdAxios["default"].post(Boilerplate.route('api.event-log.store'), {
    timestamp: getCurrentUnixTime(),
    events: events
  });
  events = [];
}
function saveEventsOnUnload() {
  addLastPageVisit();
  if (events.length === 0) {
    return;
  }
  (0, _cccisdSendBeacon["default"])(Boilerplate.route('api.event-log.store'), {
    timestamp: getCurrentUnixTime(),
    events: events
  });
}
function getCurrentUnixTime() {
  return Math.round(new Date().getTime() / 1000);
}
function getUrlHistory() {
  // grab url history from redux
  var store = window.cccisd.store;
  if (!store || !store.getState) {
    return [];
  }
  var urlHistory = (0, _get2["default"])(store.getState(), 'boilerplate.urlHistory');
  if (!urlHistory) {
    return [];
  }
  return urlHistory;
}
function getCurrentUrl() {
  var urlHistory = getUrlHistory();
  if (urlHistory.length === 0) {
    return;
  }
  return urlHistory[urlHistory.length - 1].url;
}
function addLastPageVisit() {
  var urlHistory = getUrlHistory();
  if (urlHistory.length === 0) {
    return;
  }
  var currentTime = new Date().getTime();
  var last = urlHistory[urlHistory.length - 1];
  addEvent({
    eventType: 'pageVisit',
    url: last.url,
    duration: currentTime - last.time,
    metadata: {
      onUnload: true
    }
  });
}

// Save events periodically
setInterval(saveEvents, savePeriod);

// Save events on unload
window.addEventListener('beforeunload', saveEventsOnUnload);
function addEvent(eventData) {
  var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (_typeof(eventData) !== 'object' || !eventData.eventType) {
    console.error('eventType is required when saving event log');
    return;
  }
  var data = _objectSpread({
    eventTime: getCurrentUnixTime(),
    url: eventData.url || getCurrentUrl()
  }, (0, _pick2["default"])(eventData, ['eventType', 'targetId', 'targetType', 'metadata', 'duration']));
  events.push(data);
  if (settings.saveImmediately) {
    saveEvents();
  }
}
var _default = exports["default"] = addEvent;